import React from "react";
import api from "../../api/http";
import { API_ENDPOINTS } from "../../api/endpoints";
import { CREDIT_UPDATED_EVENT } from "../../utils/creditEvent";
import { useLanguage } from "../../context/LanguageContext";
import ModalShell from "../billing/ModalShell";
import BillingProfileForm, { EMPTY_PROFILE } from "../billing/BillingProfileForm";

export const OPEN_FULL_TRIAL_MODAL = "OPEN_FULL_TRIAL_MODAL";

const FullTrialModal = ({ onClose }) => {
    const { text } = useLanguage();
    const [done, setDone] = React.useState(false);

    const submit = async (profile) => {
        await api.post(API_ENDPOINTS.UPGRADE_FULL_TRIAL, profile);
        // Refresh header credit info
        window.dispatchEvent(new Event(CREDIT_UPDATED_EVENT));
        setDone(true);
    };

    if (done) {
        return (
            <ModalShell title={text("フルトライアルを開始しました", "Full trial started")} onClose={onClose} labelledBy="full-trial-title">
                <p style={{ fontSize: 15, lineHeight: 1.7 }}>
                    {text(
                        "50クレジットをご利用いただけるようになりました。入力いただいた情報は請求先情報としても使用されます。",
                        "You now have 50 credits. The details you entered are also used as your billing information."
                    )}
                </p>
                <div style={{ textAlign: "right", marginTop: 16 }}>
                    <button type="button" onClick={onClose} style={okBtn}>{text("閉じる", "Close")}</button>
                </div>
            </ModalShell>
        );
    }

    return (
        <ModalShell
            title={text("フルトライアル申請", "Request a full trial")}
            description={text(
                "以下をご入力いただくと、トライアルのクレジットが50に増えます。",
                "Enter the details below to raise your trial to 50 credits."
            )}
            onClose={onClose}
            labelledBy="full-trial-title"
        >
            <BillingProfileForm
                initialValues={EMPTY_PROFILE}
                submitLabel={text("申請する", "Submit")}
                onSubmit={submit}
                onCancel={onClose}
            />
        </ModalShell>
    );
};

/**
 * Listens for OPEN_FULL_TRIAL_MODAL anywhere in the app (rendered by the
 * header), so the menu link works on every page, not only the top page.
 */
export const FullTrialModalHost = () => {
    const [open, setOpen] = React.useState(false);
    React.useEffect(() => {
        const show = () => setOpen(true);
        window.addEventListener(OPEN_FULL_TRIAL_MODAL, show);
        return () => window.removeEventListener(OPEN_FULL_TRIAL_MODAL, show);
    }, []);
    return open ? <FullTrialModal onClose={() => setOpen(false)} /> : null;
};

const okBtn = {
    padding: "9px 22px",
    background: "#1f63d6",
    color: "#ffffff",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 600,
};

export default FullTrialModal;
